import React from 'react';
import styles from './TransferFileButton.module.css';
import { TableScenariosIcon } from 'assets/icons/TransferFileIcon';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export const TransferFileButton = ({ onClick, disabled }) => {
    return (
        <button
            className={cx(styles.button, { 'disabledButton': disabled })}
            onClick={onClick}
            disabled={disabled}
        >
            <TableScenariosIcon/>
        </button>
    )
};

TransferFileButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
TransferFileButton.defaultProps = {
    disabled: false
};